[
  {
    "election": 26,
    "poll_id": 771,
    "poll_key": "26-771",
    "date": "2026-10-20",
    "respondents": 601,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": null,
    "jewish_power": 8,
    "together": 14,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 772,
    "poll_key": "26-772",
    "date": "2026-10-20",
    "respondents": 521,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 7,
    "raam": 6,
    "balad": null,
    "jewish_power": 9,
    "together": 12,
    "yashar": 20,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 773,
    "poll_key": "26-773",
    "date": "2026-10-20",
    "respondents": 2116,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 6,
    "religious_zionism_identity": 7,
    "raam": 6,
    "balad": null,
    "jewish_power": 8,
    "together": 9,
    "yashar": 20,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 768,
    "poll_key": "26-768",
    "date": "2026-10-19",
    "respondents": 507,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 14,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 9,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 769,
    "poll_key": "26-769",
    "date": "2026-10-19",
    "respondents": 454,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 6,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 10,
    "yashar": 19,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 770,
    "poll_key": "26-770",
    "date": "2026-10-19",
    "respondents": 1016,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 7,
    "raam": 6,
    "balad": null,
    "jewish_power": 7,
    "together": 14,
    "yashar": 20,
    "reservists": 4,
    "joint_list": 9,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 766,
    "poll_key": "26-766",
    "date": "2026-10-18",
    "respondents": 554,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 12,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 767,
    "poll_key": "26-767",
    "date": "2026-10-18",
    "respondents": 559,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 6,
    "religious_zionism_identity": 7,
    "raam": 6,
    "balad": null,
    "jewish_power": 7,
    "together": 10,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 765,
    "poll_key": "26-765",
    "date": "2026-10-16",
    "respondents": 700,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 21,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 763,
    "poll_key": "26-763",
    "date": "2026-10-15",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 11,
    "yashar": 26,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 764,
    "poll_key": "26-764",
    "date": "2026-10-15",
    "respondents": 551,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 12,
    "yashar": 24,
    "reservists": 4,
    "joint_list": 9,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 762,
    "poll_key": "26-762",
    "date": "2026-10-14",
    "respondents": 1018,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": null,
    "jewish_power": 8,
    "together": 12,
    "yashar": 20,
    "reservists": 4,
    "joint_list": 9,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 761,
    "poll_key": "26-761",
    "date": "2026-10-13",
    "respondents": 500,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 13,
    "yashar": 21,
    "reservists": 5,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 758,
    "poll_key": "26-758",
    "date": "2026-10-12",
    "respondents": 538,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 5,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 7,
    "yashar": 20,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 759,
    "poll_key": "26-759",
    "date": "2026-10-12",
    "respondents": 509,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 760,
    "poll_key": "26-760",
    "date": "2026-10-12",
    "respondents": 500,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 22,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 757,
    "poll_key": "26-757",
    "date": "2026-10-11",
    "respondents": 552,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 12,
    "yashar": 22,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 756,
    "poll_key": "26-756",
    "date": "2026-10-09",
    "respondents": 700,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 21,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 753,
    "poll_key": "26-753",
    "date": "2026-10-08",
    "respondents": 555,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 13,
    "yashar": 22,
    "reservists": 5,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 754,
    "poll_key": "26-754",
    "date": "2026-10-08",
    "respondents": 518,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 11,
    "yashar": 20,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 755,
    "poll_key": "26-755",
    "date": "2026-10-08",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 13,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 9,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 751,
    "poll_key": "26-751",
    "date": "2026-10-07",
    "respondents": 1100,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 5,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 8,
    "yashar": 23,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 752,
    "poll_key": "26-752",
    "date": "2026-10-07",
    "respondents": 1263,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 7,
    "raam": 6,
    "balad": null,
    "jewish_power": 8,
    "together": 12,
    "yashar": 20,
    "reservists": 0,
    "joint_list": 9,
    "erdan_edelstein_party": null,
    "people_of_israel": 5,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 750,
    "poll_key": "26-750",
    "date": "2026-10-06",
    "respondents": 500,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 7,
    "raam": 6,
    "balad": null,
    "jewish_power": 7,
    "together": 14,
    "yashar": 23,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 749,
    "poll_key": "26-749",
    "date": "2026-10-05",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 13,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 748,
    "poll_key": "26-748",
    "date": "2026-10-04",
    "respondents": 553,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 12,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 747,
    "poll_key": "26-747",
    "date": "2026-10-02",
    "respondents": 602,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 13,
    "yashar": 21,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 744,
    "poll_key": "26-744",
    "date": "2026-10-01",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 10,
    "yashar": 21,
    "reservists": 5,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 745,
    "poll_key": "26-745",
    "date": "2026-10-01",
    "respondents": 2175,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 6,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 8,
    "yashar": 21,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 746,
    "poll_key": "26-746",
    "date": "2026-10-01",
    "respondents": 504,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 9,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 743,
    "poll_key": "26-743",
    "date": "2026-09-30",
    "respondents": 1013,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 11,
    "yashar": 21,
    "reservists": 0,
    "joint_list": 9,
    "erdan_edelstein_party": null,
    "people_of_israel": 5,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 742,
    "poll_key": "26-742",
    "date": "2026-09-29",
    "respondents": 500,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 14,
    "yashar": 21,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 5,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 741,
    "poll_key": "26-741",
    "date": "2026-09-28",
    "respondents": 573,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 6,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 9,
    "yashar": 21,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 740,
    "poll_key": "26-740",
    "date": "2026-09-27",
    "respondents": 552,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 11,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 739,
    "poll_key": "26-739",
    "date": "2026-09-25",
    "respondents": 610,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 6,
    "shas": 6,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 13,
    "yashar": 22,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 736,
    "poll_key": "26-736",
    "date": "2026-09-24",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": null,
    "jewish_power": 6,
    "together": 12,
    "yashar": 23,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 737,
    "poll_key": "26-737",
    "date": "2026-09-24",
    "respondents": 537,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": null,
    "jewish_power": 8,
    "together": 9,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 738,
    "poll_key": "26-738",
    "date": "2026-09-24",
    "respondents": 500,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 13,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 734,
    "poll_key": "26-734",
    "date": "2026-09-23",
    "respondents": 1503,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 11,
    "yashar": 22,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 5,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 735,
    "poll_key": "26-735",
    "date": "2026-09-23",
    "respondents": 647,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 7,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 733,
    "poll_key": "26-733",
    "date": "2026-09-22",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 13,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 731,
    "poll_key": "26-731",
    "date": "2026-09-18",
    "respondents": 600,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 728,
    "poll_key": "26-728",
    "date": "2026-09-17",
    "respondents": 551,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 22,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 729,
    "poll_key": "26-729",
    "date": "2026-09-17",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 9,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": null,
    "jewish_power": 7,
    "together": 14,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 730,
    "poll_key": "26-730",
    "date": "2026-09-17",
    "respondents": 519,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 9,
    "yashar": 21,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 5,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 732,
    "poll_key": "26-732",
    "date": "2026-09-17",
    "respondents": 483,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 9,
    "yashar": 20,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 726,
    "poll_key": "26-726",
    "date": "2026-09-16",
    "respondents": 500,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 16,
    "yashar": 21,
    "reservists": 4,
    "joint_list": 6,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 727,
    "poll_key": "26-727",
    "date": "2026-09-16",
    "respondents": 886,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 8,
    "raam": 6,
    "balad": null,
    "jewish_power": 8,
    "together": 12,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 6,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 725,
    "poll_key": "26-725",
    "date": "2026-09-15",
    "respondents": 483,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 6,
    "religious_zionism_identity": 8,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 8,
    "yashar": 21,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 723,
    "poll_key": "26-723",
    "date": "2026-09-14",
    "respondents": 551,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 12,
    "yashar": 24,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 724,
    "poll_key": "26-724",
    "date": "2026-09-14",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": null,
    "jewish_power": 6,
    "together": 13,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 722,
    "poll_key": "26-722",
    "date": "2026-09-11",
    "respondents": 601,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 14,
    "yashar": 25,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 720,
    "poll_key": "26-720",
    "date": "2026-09-10",
    "respondents": 500,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 16,
    "yashar": 23,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 721,
    "poll_key": "26-721",
    "date": "2026-09-10",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 15,
    "yashar": 23,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 714,
    "poll_key": "26-714",
    "date": "2026-09-09",
    "respondents": 506,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 14,
    "yashar": 25,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 715,
    "poll_key": "26-715",
    "date": "2026-09-09",
    "respondents": 1119,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": null,
    "jewish_power": 9,
    "together": 13,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 716,
    "poll_key": "26-716",
    "date": "2026-09-09",
    "respondents": 554,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 12,
    "yashar": 24,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 717,
    "poll_key": "26-717",
    "date": "2026-09-09",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": null,
    "jewish_power": 6,
    "together": 13,
    "yashar": 25,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 5,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 718,
    "poll_key": "26-718",
    "date": "2026-09-09",
    "respondents": 1054,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 10,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 719,
    "poll_key": "26-719",
    "date": "2026-09-09",
    "respondents": 537,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 8,
    "raam": 6,
    "balad": null,
    "jewish_power": 8,
    "together": 7,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 6,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 713,
    "poll_key": "26-713",
    "date": "2026-09-08",
    "respondents": 600,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 25,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 711,
    "poll_key": "26-711",
    "date": "2026-09-07",
    "respondents": 1057,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 6,
    "religious_zionism_identity": 8,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 6,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 712,
    "poll_key": "26-712",
    "date": "2026-09-07",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 4,
    "balad": null,
    "jewish_power": 6,
    "together": 13,
    "yashar": 25,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 710,
    "poll_key": "26-710",
    "date": "2026-09-06",
    "respondents": 551,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": null,
    "jewish_power": 7,
    "together": 13,
    "yashar": 23,
    "reservists": 4,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": 4,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 709,
    "poll_key": "26-709",
    "date": "2026-09-04",
    "respondents": 600,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 15,
    "yashar": 23,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 4,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 706,
    "poll_key": "26-706",
    "date": "2026-09-03",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 15,
    "yashar": 22,
    "reservists": 4,
    "joint_list": 6,
    "erdan_edelstein_party": 0,
    "people_of_israel": 0,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 707,
    "poll_key": "26-707",
    "date": "2026-09-03",
    "respondents": 865,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 6,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 9,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 708,
    "poll_key": "26-708",
    "date": "2026-09-03",
    "respondents": 555,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 13,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 4,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 702,
    "poll_key": "26-702",
    "date": "2026-09-02",
    "respondents": 500,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 15,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": 0,
    "people_of_israel": 0,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 703,
    "poll_key": "26-703",
    "date": "2026-09-02",
    "respondents": 522,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 9,
    "yashar": 23,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 5,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 704,
    "poll_key": "26-704",
    "date": "2026-09-02",
    "respondents": 940,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 12,
    "yashar": 22,
    "reservists": 0,
    "joint_list": 9,
    "erdan_edelstein_party": 0,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 705,
    "poll_key": "26-705",
    "date": "2026-09-02",
    "respondents": 552,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": null,
    "jewish_power": 9,
    "together": 18,
    "yashar": 20,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 5,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 701,
    "poll_key": "26-701",
    "date": "2026-08-31",
    "respondents": 506,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": null,
    "jewish_power": 8,
    "together": 15,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 699,
    "poll_key": "26-699",
    "date": "2026-08-30",
    "respondents": 551,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 14,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": 0,
    "people_of_israel": 4,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 700,
    "poll_key": "26-700",
    "date": "2026-08-30",
    "respondents": 666,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 6,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 698,
    "poll_key": "26-698",
    "date": "2026-08-28",
    "respondents": 506,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 15,
    "yashar": 25,
    "reservists": 0,
    "joint_list": 8,
    "erdan_edelstein_party": 0,
    "people_of_israel": 5,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 696,
    "poll_key": "26-696",
    "date": "2026-08-27",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 14,
    "yashar": 26,
    "reservists": 0,
    "joint_list": 6,
    "erdan_edelstein_party": 0,
    "people_of_israel": 6,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 697,
    "poll_key": "26-697",
    "date": "2026-08-27",
    "respondents": 981,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 6,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 7,
    "yashar": 23,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 4,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 691,
    "poll_key": "26-691",
    "date": "2026-08-26",
    "respondents": 500,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 15,
    "yashar": 25,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 6,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 692,
    "poll_key": "26-692",
    "date": "2026-08-26",
    "respondents": 532,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": null,
    "jewish_power": 6,
    "together": 8,
    "yashar": 23,
    "reservists": 0,
    "joint_list": 6,
    "erdan_edelstein_party": 0,
    "people_of_israel": 8,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 693,
    "poll_key": "26-693",
    "date": "2026-08-26",
    "respondents": 552,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": null,
    "jewish_power": 9,
    "together": 16,
    "yashar": 21,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 7,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 694,
    "poll_key": "26-694",
    "date": "2026-08-26",
    "respondents": 1407,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 10,
    "erdan_edelstein_party": 0,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 689,
    "poll_key": "26-689",
    "date": "2026-08-24",
    "respondents": 486,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 7,
    "yashar": 24,
    "reservists": null,
    "joint_list": 5,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 690,
    "poll_key": "26-690",
    "date": "2026-08-24",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": null,
    "jewish_power": 9,
    "together": 15,
    "yashar": 24,
    "reservists": null,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 695,
    "poll_key": "26-695",
    "date": "2026-08-24",
    "respondents": 486,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 7,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 5,
    "erdan_edelstein_party": 0,
    "people_of_israel": 0,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 688,
    "poll_key": "26-688",
    "date": "2026-08-23",
    "respondents": 552,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 14,
    "yashar": 24,
    "reservists": 0,
    "joint_list": 7,
    "erdan_edelstein_party": 0,
    "people_of_israel": 0,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 687,
    "poll_key": "26-687",
    "date": "2026-08-21",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 14,
    "yashar": 26,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 685,
    "poll_key": "26-685",
    "date": "2026-08-20",
    "respondents": 400,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 11,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 15,
    "yashar": 23,
    "reservists": null,
    "joint_list": 7,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 686,
    "poll_key": "26-686",
    "date": "2026-08-20",
    "respondents": 553,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 13,
    "yashar": 23,
    "reservists": null,
    "joint_list": 8,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 682,
    "poll_key": "26-682",
    "date": "2026-08-19",
    "respondents": 558,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 14,
    "yashar": 24,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 683,
    "poll_key": "26-683",
    "date": "2026-08-19",
    "respondents": 500,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": null,
    "jewish_power": 9,
    "together": 16,
    "yashar": 25,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 684,
    "poll_key": "26-684",
    "date": "2026-08-19",
    "respondents": 961,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 26,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 681,
    "poll_key": "26-681",
    "date": "2026-08-18",
    "respondents": 522,
    "media_outlet": "i24 news",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 9,
    "yashar": 24,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Direct Polls",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 680,
    "poll_key": "26-680",
    "date": "2026-08-17",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 15,
    "yashar": 24,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 679,
    "poll_key": "26-679",
    "date": "2026-08-16",
    "respondents": 1103,
    "media_outlet": "כאן חדשות",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 14,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": 0,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 678,
    "poll_key": "26-678",
    "date": "2026-08-14",
    "respondents": 506,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 14,
    "yashar": 23,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": 0,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 676,
    "poll_key": "26-676",
    "date": "2026-08-13",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 11,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": null,
    "jewish_power": 7,
    "together": 13,
    "yashar": 25,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": 0,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 677,
    "poll_key": "26-677",
    "date": "2026-08-13",
    "respondents": 512,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 9,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 8,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": 0,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 675,
    "poll_key": "26-675",
    "date": "2026-08-12",
    "respondents": 1240,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 12,
    "yashar": 23,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": 0,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 672,
    "poll_key": "26-672",
    "date": "2026-08-10",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 15,
    "yashar": 24,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": 0,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 673,
    "poll_key": "26-673",
    "date": "2026-08-10",
    "respondents": 741,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 7,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": 0,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 674,
    "poll_key": "26-674",
    "date": "2026-08-10",
    "respondents": 500,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 16,
    "yashar": 22,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": 0,
    "people_of_israel": null,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 671,
    "poll_key": "26-671",
    "date": "2026-08-09",
    "respondents": 551,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 13,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 670,
    "poll_key": "26-670",
    "date": "2026-08-07",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 15,
    "yashar": 23,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 667,
    "poll_key": "26-667",
    "date": "2026-08-06",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 11,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": null,
    "jewish_power": 8,
    "together": 15,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 668,
    "poll_key": "26-668",
    "date": "2026-08-06",
    "respondents": 552,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": 13,
    "yashar": 22,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 669,
    "poll_key": "26-669",
    "date": "2026-08-06",
    "respondents": 535,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 9,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 8,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 7,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 666,
    "poll_key": "26-666",
    "date": "2026-08-05",
    "respondents": 961,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 13,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 664,
    "poll_key": "26-664",
    "date": "2026-08-04",
    "respondents": 588,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 8,
    "yashar": 22,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 665,
    "poll_key": "26-665",
    "date": "2026-08-04",
    "respondents": 500,
    "media_outlet": "ערוץ 16",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 14,
    "yashar": 22,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 16",
    "pollster_en": "Yitzhak Katz",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 663,
    "poll_key": "26-663",
    "date": "2026-08-03",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 14,
    "yashar": 23,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 662,
    "poll_key": "26-662",
    "date": "2026-08-02",
    "respondents": 551,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 13,
    "yashar": 23,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 661,
    "poll_key": "26-661",
    "date": "2026-07-31",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 15,
    "yashar": 23,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 660,
    "poll_key": "26-660",
    "date": "2026-07-30",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 4,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 13,
    "yashar": 21,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 658,
    "poll_key": "26-658",
    "date": "2026-07-29",
    "respondents": 956,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 9,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 13,
    "yashar": 23,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 659,
    "poll_key": "26-659",
    "date": "2026-07-29",
    "respondents": 539,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 7,
    "yashar": 22,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 656,
    "poll_key": "26-656",
    "date": "2026-07-27",
    "respondents": 509,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 14,
    "yashar": 23,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 657,
    "poll_key": "26-657",
    "date": "2026-07-27",
    "respondents": 525,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 7,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 9,
    "yashar": 21,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 654,
    "poll_key": "26-654",
    "date": "2026-07-26",
    "respondents": 878,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 7,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 655,
    "poll_key": "26-655",
    "date": "2026-07-26",
    "respondents": 550,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 14,
    "yashar": 21,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 653,
    "poll_key": "26-653",
    "date": "2026-07-24",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 17,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 651,
    "poll_key": "26-651",
    "date": "2026-07-23",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 25,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 652,
    "poll_key": "26-652",
    "date": "2026-07-23",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": 14,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 650,
    "poll_key": "26-650",
    "date": "2026-07-21",
    "respondents": 988,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 14,
    "yashar": 21,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 649,
    "poll_key": "26-649",
    "date": "2026-07-20",
    "respondents": 507,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 15,
    "yashar": 24,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 648,
    "poll_key": "26-648",
    "date": "2026-07-19",
    "respondents": 551,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 15,
    "yashar": 22,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 647,
    "poll_key": "26-647",
    "date": "2026-07-17",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 16,
    "yashar": 22,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 644,
    "poll_key": "26-644",
    "date": "2026-07-16",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": null,
    "jewish_power": 7,
    "together": 15,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 645,
    "poll_key": "26-645",
    "date": "2026-07-16",
    "respondents": 550,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 7,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 9,
    "yashar": 22,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 646,
    "poll_key": "26-646",
    "date": "2026-07-16",
    "respondents": 606,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 8,
    "yashar": 21,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 643,
    "poll_key": "26-643",
    "date": "2026-07-15",
    "respondents": 851,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 6,
    "raam": 4,
    "balad": 0,
    "jewish_power": 7,
    "together": 15,
    "yashar": 21,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 642,
    "poll_key": "26-642",
    "date": "2026-07-13",
    "respondents": 509,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 16,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 641,
    "poll_key": "26-641",
    "date": "2026-07-12",
    "respondents": 551,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 15,
    "yashar": 24,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 640,
    "poll_key": "26-640",
    "date": "2026-07-10",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 18,
    "yashar": 22,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 637,
    "poll_key": "26-637",
    "date": "2026-07-09",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 14,
    "yashar": 23,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 638,
    "poll_key": "26-638",
    "date": "2026-07-09",
    "respondents": 527,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 7,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 9,
    "yashar": 21,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 639,
    "poll_key": "26-639",
    "date": "2026-07-09",
    "respondents": 691,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 9,
    "yashar": 20,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 636,
    "poll_key": "26-636",
    "date": "2026-07-08",
    "respondents": 956,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 15,
    "yashar": 23,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 635,
    "poll_key": "26-635",
    "date": "2026-07-06",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": null,
    "jewish_power": 9,
    "together": 16,
    "yashar": 23,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 634,
    "poll_key": "26-634",
    "date": "2026-07-05",
    "respondents": 553,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": null,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": null,
    "jewish_power": 9,
    "together": 16,
    "yashar": 23,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 633,
    "poll_key": "26-633",
    "date": "2026-07-03",
    "respondents": 606,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 19,
    "yashar": 20,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 631,
    "poll_key": "26-631",
    "date": "2026-07-02",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 16,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 632,
    "poll_key": "26-632",
    "date": "2026-07-02",
    "respondents": 691,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 9,
    "yashar": 20,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 630,
    "poll_key": "26-630",
    "date": "2026-07-01",
    "respondents": 1108,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 17,
    "yashar": 20,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 629,
    "poll_key": "26-629",
    "date": "2026-06-30",
    "respondents": 500,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 7,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 11,
    "yashar": 19,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 628,
    "poll_key": "26-628",
    "date": "2026-06-29",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 17,
    "yashar": 22,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 626,
    "poll_key": "26-626",
    "date": "2026-06-26",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 18,
    "yashar": 21,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 622,
    "poll_key": "26-622",
    "date": "2026-06-25",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 7,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 16,
    "yashar": 21,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 623,
    "poll_key": "26-623",
    "date": "2026-06-25",
    "respondents": 654,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": null,
    "jewish_power": 7,
    "together": 9,
    "yashar": 20,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 624,
    "poll_key": "26-624",
    "date": "2026-06-25",
    "respondents": 530,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 7,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 11,
    "yashar": 20,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 625,
    "poll_key": "26-625",
    "date": "2026-06-25",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 18,
    "yashar": 21,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 627,
    "poll_key": "26-627",
    "date": "2026-06-25",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": null,
    "hadash_taal": 4,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 17,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 7,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 620,
    "poll_key": "26-620",
    "date": "2026-06-24",
    "respondents": 1301,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 12,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 15,
    "yashar": 20,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 621,
    "poll_key": "26-621",
    "date": "2026-06-24",
    "respondents": 553,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 16,
    "yashar": 22,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 619,
    "poll_key": "26-619",
    "date": "2026-06-19",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 20,
    "yashar": 21,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 616,
    "poll_key": "26-616",
    "date": "2026-06-18",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 19,
    "yashar": 23,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 617,
    "poll_key": "26-617",
    "date": "2026-06-18",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 19,
    "yashar": 21,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 618,
    "poll_key": "26-618",
    "date": "2026-06-18",
    "respondents": 1552,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 10,
    "yashar": 20,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 615,
    "poll_key": "26-615",
    "date": "2026-06-17",
    "respondents": 973,
    "media_outlet": "חדשות 13",
    "pollster": "המדד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 17,
    "yashar": 20,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "HaMadad",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 613,
    "poll_key": "26-613",
    "date": "2026-06-16",
    "respondents": 555,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 7,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 17,
    "yashar": 21,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 614,
    "poll_key": "26-614",
    "date": "2026-06-16",
    "respondents": 588,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 7,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 12,
    "yashar": 18,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 612,
    "poll_key": "26-612",
    "date": "2026-06-12",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 20,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 607,
    "poll_key": "26-607",
    "date": "2026-06-11",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 19,
    "yashar": 20,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 608,
    "poll_key": "26-608",
    "date": "2026-06-11",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 21,
    "yashar": 21,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 609,
    "poll_key": "26-609",
    "date": "2026-06-11",
    "respondents": 554,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 7,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": null,
    "jewish_power": 9,
    "together": 12,
    "yashar": 17,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 610,
    "poll_key": "26-610",
    "date": "2026-06-11",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 20,
    "yashar": 20,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 611,
    "poll_key": "26-611",
    "date": "2026-06-11",
    "respondents": 771,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 13,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 603,
    "poll_key": "26-603",
    "date": "2026-06-05",
    "respondents": 505,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 21,
    "yashar": 19,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 606,
    "poll_key": "26-606",
    "date": "2026-06-05",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 17,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 601,
    "poll_key": "26-601",
    "date": "2026-06-04",
    "respondents": 515,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 14,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 602,
    "poll_key": "26-602",
    "date": "2026-06-04",
    "respondents": 531,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 14,
    "yashar": 16,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 604,
    "poll_key": "26-604",
    "date": "2026-06-04",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": null,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 6,
    "together": 21,
    "yashar": 19,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 605,
    "poll_key": "26-605",
    "date": "2026-06-04",
    "respondents": 551,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 10,
    "together": 23,
    "yashar": 17,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 600,
    "poll_key": "26-600",
    "date": "2026-05-29",
    "respondents": 503,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 17,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 594,
    "poll_key": "26-594",
    "date": "2026-05-28",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 17,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 595,
    "poll_key": "26-595",
    "date": "2026-05-28",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 14,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 21,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 596,
    "poll_key": "26-596",
    "date": "2026-05-28",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 22,
    "yashar": 18,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 597,
    "poll_key": "26-597",
    "date": "2026-05-28",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 13,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 6,
    "together": 22,
    "yashar": 17,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 7,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 598,
    "poll_key": "26-598",
    "date": "2026-05-28",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 17,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 599,
    "poll_key": "26-599",
    "date": "2026-05-28",
    "respondents": 615,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 15,
    "yashar": 15,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 593,
    "poll_key": "26-593",
    "date": "2026-05-25",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 10,
    "together": 23,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 591,
    "poll_key": "26-591",
    "date": "2026-05-21",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 25,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 588,
    "poll_key": "26-588",
    "date": "2026-05-20",
    "respondents": 551,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 589,
    "poll_key": "26-589",
    "date": "2026-05-20",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 23,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 590,
    "poll_key": "26-590",
    "date": "2026-05-20",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": null,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 23,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 587,
    "poll_key": "26-587",
    "date": "2026-05-19",
    "respondents": 546,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 15,
    "yashar": 17,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 586,
    "poll_key": "26-586",
    "date": "2026-05-15",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 26,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 582,
    "poll_key": "26-582",
    "date": "2026-05-14",
    "respondents": 506,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 24,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 583,
    "poll_key": "26-583",
    "date": "2026-05-14",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 24,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 584,
    "poll_key": "26-584",
    "date": "2026-05-14",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 24,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 585,
    "poll_key": "26-585",
    "date": "2026-05-14",
    "respondents": 436,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 16,
    "yashar": 14,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 581,
    "poll_key": "26-581",
    "date": "2026-05-13",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 26,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 580,
    "poll_key": "26-580",
    "date": "2026-05-12",
    "respondents": 557,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 25,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 579,
    "poll_key": "26-579",
    "date": "2026-05-08",
    "respondents": 503,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 26,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 576,
    "poll_key": "26-576",
    "date": "2026-05-07",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": null,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 26,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 577,
    "poll_key": "26-577",
    "date": "2026-05-07",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 25,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 578,
    "poll_key": "26-578",
    "date": "2026-05-07",
    "respondents": 721,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 16,
    "yashar": 13,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 575,
    "poll_key": "26-575",
    "date": "2026-05-01",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 28,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 572,
    "poll_key": "26-572",
    "date": "2026-04-30",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 28,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 573,
    "poll_key": "26-573",
    "date": "2026-04-30",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 574,
    "poll_key": "26-574",
    "date": "2026-04-30",
    "respondents": 624,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 18,
    "yashar": 12,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 566,
    "poll_key": "26-566",
    "date": "2026-04-27",
    "respondents": 500,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 27,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 567,
    "poll_key": "26-567",
    "date": "2026-04-27",
    "respondents": 555,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 24,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 568,
    "poll_key": "26-568",
    "date": "2026-04-27",
    "respondents": 555,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 9,
    "together": 23,
    "yashar": 14,
    "reservists": 0,
    "joint_list": 13,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 569,
    "poll_key": "26-569",
    "date": "2026-04-27",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 26,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 570,
    "poll_key": "26-570",
    "date": "2026-04-27",
    "respondents": 578,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 4,
    "israel_our_home": 6,
    "religious_zionism_identity": 4,
    "raam": 7,
    "balad": 0,
    "jewish_power": 6,
    "together": 24,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 571,
    "poll_key": "26-571",
    "date": "2026-04-27",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 26,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 565,
    "poll_key": "26-565",
    "date": "2026-04-26",
    "respondents": 932,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": null,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 20,
    "yashar": 9,
    "reservists": null,
    "joint_list": 11,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 564,
    "poll_key": "26-564",
    "date": "2026-04-24",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 24,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 561,
    "poll_key": "26-561",
    "date": "2026-04-23",
    "respondents": 958,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 10,
    "yashar": 12,
    "reservists": null,
    "joint_list": 11,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 562,
    "poll_key": "26-562",
    "date": "2026-04-23",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 563,
    "poll_key": "26-563",
    "date": "2026-04-23",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 9,
    "together": 21,
    "yashar": 14,
    "reservists": 0,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 560,
    "poll_key": "26-560",
    "date": "2026-04-17",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 24,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 555,
    "poll_key": "26-555",
    "date": "2026-04-16",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 5,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 16,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 556,
    "poll_key": "26-556",
    "date": "2026-04-16",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 20,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 557,
    "poll_key": "26-557",
    "date": "2026-04-16",
    "respondents": 511,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 0,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 11,
    "yashar": 13,
    "reservists": null,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 558,
    "poll_key": "26-558",
    "date": "2026-04-16",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 20,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 559,
    "poll_key": "26-559",
    "date": "2026-04-16",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 10,
    "together": 20,
    "yashar": 14,
    "reservists": 0,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 554,
    "poll_key": "26-554",
    "date": "2026-04-10",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 24,
    "yashar": 13,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 549,
    "poll_key": "26-549",
    "date": "2026-04-09",
    "respondents": 552,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 19,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 550,
    "poll_key": "26-550",
    "date": "2026-04-09",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 13,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 551,
    "poll_key": "26-551",
    "date": "2026-04-09",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 21,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 552,
    "poll_key": "26-552",
    "date": "2026-04-09",
    "respondents": 951,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 10,
    "yashar": 12,
    "reservists": null,
    "joint_list": 11,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 553,
    "poll_key": "26-553",
    "date": "2026-04-09",
    "respondents": 532,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 0,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 7,
    "balad": 0,
    "jewish_power": 9,
    "together": 11,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 547,
    "poll_key": "26-547",
    "date": "2026-04-03",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 546,
    "poll_key": "26-546",
    "date": "2026-03-29",
    "respondents": 553,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 19,
    "yashar": 13,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 545,
    "poll_key": "26-545",
    "date": "2026-03-27",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 13,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 541,
    "poll_key": "26-541",
    "date": "2026-03-26",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 16,
    "yashar": 17,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 542,
    "poll_key": "26-542",
    "date": "2026-03-26",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 20,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 543,
    "poll_key": "26-543",
    "date": "2026-03-26",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 9,
    "together": 20,
    "yashar": 12,
    "reservists": 0,
    "joint_list": 11,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 544,
    "poll_key": "26-544",
    "date": "2026-03-26",
    "respondents": 703,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 10,
    "yashar": 11,
    "reservists": null,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 540,
    "poll_key": "26-540",
    "date": "2026-03-25",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 7,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 18,
    "yashar": 13,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 7,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 538,
    "poll_key": "26-538",
    "date": "2026-03-20",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 21,
    "yashar": 11,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 539,
    "poll_key": "26-539",
    "date": "2026-03-20",
    "respondents": 534,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 4,
    "israel_our_home": 7,
    "religious_zionism_identity": 4,
    "raam": 7,
    "balad": 0,
    "jewish_power": 7,
    "together": 13,
    "yashar": 13,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 534,
    "poll_key": "26-534",
    "date": "2026-03-19",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 4,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 15,
    "yashar": 16,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 535,
    "poll_key": "26-535",
    "date": "2026-03-19",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 20,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 536,
    "poll_key": "26-536",
    "date": "2026-03-19",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 20,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 537,
    "poll_key": "26-537",
    "date": "2026-03-19",
    "respondents": 754,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 36,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 10,
    "yashar": 11,
    "reservists": null,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 533,
    "poll_key": "26-533",
    "date": "2026-03-13",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 13,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 530,
    "poll_key": "26-530",
    "date": "2026-03-12",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 17,
    "yashar": 15,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 531,
    "poll_key": "26-531",
    "date": "2026-03-12",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 11,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 532,
    "poll_key": "26-532",
    "date": "2026-03-12",
    "respondents": 661,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 10,
    "yashar": 11,
    "reservists": null,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 529,
    "poll_key": "26-529",
    "date": "2026-03-10",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 9,
    "together": 17,
    "yashar": 13,
    "reservists": 0,
    "joint_list": 16,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 7,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 528,
    "poll_key": "26-528",
    "date": "2026-03-06",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 526,
    "poll_key": "26-526",
    "date": "2026-03-05",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 15,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 527,
    "poll_key": "26-527",
    "date": "2026-03-05",
    "respondents": 742,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 9,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 11,
    "yashar": 10,
    "reservists": 0,
    "joint_list": 13,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 524,
    "poll_key": "26-524",
    "date": "2026-02-27",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 19,
    "yashar": 14,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 525,
    "poll_key": "26-525",
    "date": "2026-02-27",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 9,
    "together": 20,
    "yashar": 13,
    "reservists": 0,
    "joint_list": 14,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 521,
    "poll_key": "26-521",
    "date": "2026-02-26",
    "respondents": 579,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 10,
    "yashar": 11,
    "reservists": 0,
    "joint_list": 13,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 522,
    "poll_key": "26-522",
    "date": "2026-02-26",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 18,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 523,
    "poll_key": "26-523",
    "date": "2026-02-26",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 10,
    "together": 21,
    "yashar": 11,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 519,
    "poll_key": "26-519",
    "date": "2026-02-20",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 20,
    "yashar": 13,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 520,
    "poll_key": "26-520",
    "date": "2026-02-20",
    "respondents": 535,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 0,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 14,
    "yashar": 11,
    "reservists": 0,
    "joint_list": 14,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 515,
    "poll_key": "26-515",
    "date": "2026-02-19",
    "respondents": 1024,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 5,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 11,
    "yashar": 9,
    "reservists": 0,
    "joint_list": 13,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 516,
    "poll_key": "26-516",
    "date": "2026-02-19",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 10,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 517,
    "poll_key": "26-517",
    "date": "2026-02-19",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 9,
    "together": 20,
    "yashar": 10,
    "reservists": 0,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 518,
    "poll_key": "26-518",
    "date": "2026-02-19",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 18,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 514,
    "poll_key": "26-514",
    "date": "2026-02-17",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 22,
    "yashar": 9,
    "reservists": 0,
    "joint_list": 15,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 7,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 513,
    "poll_key": "26-513",
    "date": "2026-02-13",
    "respondents": 593,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 21,
    "yashar": 12,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 506,
    "poll_key": "26-506",
    "date": "2026-02-12",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 21,
    "yashar": 11,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 507,
    "poll_key": "26-507",
    "date": "2026-02-12",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 10,
    "together": 20,
    "yashar": 10,
    "reservists": 0,
    "joint_list": 13,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 508,
    "poll_key": "26-508",
    "date": "2026-02-12",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 20,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 509,
    "poll_key": "26-509",
    "date": "2026-02-12",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 19,
    "yashar": 8,
    "reservists": 0,
    "joint_list": 15,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 510,
    "poll_key": "26-510",
    "date": "2026-02-12",
    "respondents": 508,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 11,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 511,
    "poll_key": "26-511",
    "date": "2026-02-12",
    "respondents": 508,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 9,
    "together": 20,
    "yashar": 11,
    "reservists": 0,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 512,
    "poll_key": "26-512",
    "date": "2026-02-12",
    "respondents": 532,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 5,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 10,
    "yashar": 8,
    "reservists": 0,
    "joint_list": 13,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 504,
    "poll_key": "26-504",
    "date": "2026-02-06",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 23,
    "yashar": 9,
    "reservists": 0,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 505,
    "poll_key": "26-505",
    "date": "2026-02-06",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 24,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 500,
    "poll_key": "26-500",
    "date": "2026-02-05",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 23,
    "yashar": 10,
    "reservists": 0,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 501,
    "poll_key": "26-501",
    "date": "2026-02-05",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 23,
    "yashar": 10,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 502,
    "poll_key": "26-502",
    "date": "2026-02-05",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 18,
    "yashar": 6,
    "reservists": 0,
    "joint_list": 14,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 503,
    "poll_key": "26-503",
    "date": "2026-02-05",
    "respondents": 644,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 9,
    "shas": 11,
    "blue_and_white": 4,
    "there_is_a_future": 4,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 11,
    "yashar": 6,
    "reservists": 0,
    "joint_list": 13,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 499,
    "poll_key": "26-499",
    "date": "2026-02-04",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 6,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": null,
    "israel_our_home": 7,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 9,
    "together": 22,
    "yashar": 6,
    "reservists": 0,
    "joint_list": 15,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 494,
    "poll_key": "26-494",
    "date": "2026-01-30",
    "respondents": 503,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 22,
    "yashar": 10,
    "reservists": 0,
    "joint_list": 13,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 491,
    "poll_key": "26-491",
    "date": "2026-01-29",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": null,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 19,
    "yashar": 7,
    "reservists": 0,
    "joint_list": 16,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 492,
    "poll_key": "26-492",
    "date": "2026-01-29",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": null,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": null,
    "balad": null,
    "jewish_power": 8,
    "together": 21,
    "yashar": 9,
    "reservists": 0,
    "joint_list": 12,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 493,
    "poll_key": "26-493",
    "date": "2026-01-29",
    "respondents": 952,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": null,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": null,
    "balad": null,
    "jewish_power": 7,
    "together": 12,
    "yashar": 7,
    "reservists": null,
    "joint_list": 13,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 490,
    "poll_key": "26-490",
    "date": "2026-01-23",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 11,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 487,
    "poll_key": "26-487",
    "date": "2026-01-22",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 18,
    "yashar": 7,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 488,
    "poll_key": "26-488",
    "date": "2026-01-22",
    "respondents": 503,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 5,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 10,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 489,
    "poll_key": "26-489",
    "date": "2026-01-22",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 486,
    "poll_key": "26-486",
    "date": "2026-01-20",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 4,
    "jewish_power": 9,
    "together": 23,
    "yashar": 7,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 485,
    "poll_key": "26-485",
    "date": "2026-01-16",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 10,
    "together": 22,
    "yashar": 11,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 480,
    "poll_key": "26-480",
    "date": "2026-01-15",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 19,
    "yashar": 7,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 481,
    "poll_key": "26-481",
    "date": "2026-01-15",
    "respondents": 600,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": [
      "exact_payload_duplicate_group_1"
    ]
  },
  {
    "election": 26,
    "poll_id": 482,
    "poll_key": "26-482",
    "date": "2026-01-15",
    "respondents": 600,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": [
      "exact_payload_duplicate_group_1"
    ]
  },
  {
    "election": 26,
    "poll_id": 483,
    "poll_key": "26-483",
    "date": "2026-01-15",
    "respondents": 604,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 11,
    "yashar": 6,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 484,
    "poll_key": "26-484",
    "date": "2026-01-15",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 479,
    "poll_key": "26-479",
    "date": "2026-01-09",
    "respondents": 503,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 10,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 476,
    "poll_key": "26-476",
    "date": "2026-01-08",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 21,
    "yashar": 6,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 477,
    "poll_key": "26-477",
    "date": "2026-01-08",
    "respondents": 506,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 13,
    "yashar": 8,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 478,
    "poll_key": "26-478",
    "date": "2026-01-08",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 21,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 474,
    "poll_key": "26-474",
    "date": "2026-01-07",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 24,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 473,
    "poll_key": "26-473",
    "date": "2026-01-02",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 19,
    "yashar": 10,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 470,
    "poll_key": "26-470",
    "date": "2026-01-01",
    "respondents": 736,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 11,
    "yashar": 8,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 471,
    "poll_key": "26-471",
    "date": "2026-01-01",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 472,
    "poll_key": "26-472",
    "date": "2026-01-01",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 22,
    "yashar": 7,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 469,
    "poll_key": "26-469",
    "date": "2025-12-28",
    "respondents": 500,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 20,
    "yashar": 9,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 468,
    "poll_key": "26-468",
    "date": "2025-12-26",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 10,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 464,
    "poll_key": "26-464",
    "date": "2025-12-25",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 5,
    "together": 20,
    "yashar": 5,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 465,
    "poll_key": "26-465",
    "date": "2025-12-25",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 21,
    "yashar": 8,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 466,
    "poll_key": "26-466",
    "date": "2025-12-25",
    "respondents": 657,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 12,
    "yashar": 8,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 467,
    "poll_key": "26-467",
    "date": "2025-12-25",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 7,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 463,
    "poll_key": "26-463",
    "date": "2025-12-23",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 10,
    "together": 22,
    "yashar": 6,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 461,
    "poll_key": "26-461",
    "date": "2025-12-19",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 10,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 462,
    "poll_key": "26-462",
    "date": "2025-12-19",
    "respondents": 544,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 0,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 20,
    "yashar": 5,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 459,
    "poll_key": "26-459",
    "date": "2025-12-18",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 20,
    "yashar": 6,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 460,
    "poll_key": "26-460",
    "date": "2025-12-18",
    "respondents": 491,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 36,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 11,
    "yashar": 8,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 458,
    "poll_key": "26-458",
    "date": "2025-12-12",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 20,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 455,
    "poll_key": "26-455",
    "date": "2025-12-11",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 21,
    "yashar": 5,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 456,
    "poll_key": "26-456",
    "date": "2025-12-11",
    "respondents": 657,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 13,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 457,
    "poll_key": "26-457",
    "date": "2025-12-11",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 453,
    "poll_key": "26-453",
    "date": "2025-12-05",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 454,
    "poll_key": "26-454",
    "date": "2025-12-05",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 6,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 19,
    "yashar": 6,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 449,
    "poll_key": "26-449",
    "date": "2025-12-04",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 20,
    "yashar": 7,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 450,
    "poll_key": "26-450",
    "date": "2025-12-04",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 23,
    "yashar": 7,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 451,
    "poll_key": "26-451",
    "date": "2025-12-04",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 21,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 452,
    "poll_key": "26-452",
    "date": "2025-12-04",
    "respondents": 1119,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 12,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 448,
    "poll_key": "26-448",
    "date": "2025-12-01",
    "respondents": 500,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 0,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 19,
    "yashar": 4,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 447,
    "poll_key": "26-447",
    "date": "2025-11-30",
    "respondents": 555,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 7,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 446,
    "poll_key": "26-446",
    "date": "2025-11-28",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 8,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 443,
    "poll_key": "26-443",
    "date": "2025-11-27",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 11,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 20,
    "yashar": 6,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 444,
    "poll_key": "26-444",
    "date": "2025-11-27",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 7,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 445,
    "poll_key": "26-445",
    "date": "2025-11-27",
    "respondents": 467,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 10,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 441,
    "poll_key": "26-441",
    "date": "2025-11-21",
    "respondents": 504,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 442,
    "poll_key": "26-442",
    "date": "2025-11-21",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 23,
    "yashar": 6,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 438,
    "poll_key": "26-438",
    "date": "2025-11-20",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 11,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 19,
    "yashar": 5,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 439,
    "poll_key": "26-439",
    "date": "2025-11-20",
    "respondents": 588,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 9,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 12,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 440,
    "poll_key": "26-440",
    "date": "2025-11-20",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 437,
    "poll_key": "26-437",
    "date": "2025-11-14",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 24,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 433,
    "poll_key": "26-433",
    "date": "2025-11-13",
    "respondents": 605,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 6,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 434,
    "poll_key": "26-434",
    "date": "2025-11-13",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 19,
    "yashar": 5,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 435,
    "poll_key": "26-435",
    "date": "2025-11-13",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 436,
    "poll_key": "26-436",
    "date": "2025-11-13",
    "respondents": 602,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 9,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 12,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 432,
    "poll_key": "26-432",
    "date": "2025-11-07",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 22,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 429,
    "poll_key": "26-429",
    "date": "2025-11-06",
    "respondents": 505,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 9,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 21,
    "yashar": 5,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 430,
    "poll_key": "26-430",
    "date": "2025-11-06",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 431,
    "poll_key": "26-431",
    "date": "2025-11-06",
    "respondents": 496,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 12,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 428,
    "poll_key": "26-428",
    "date": "2025-10-31",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 21,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 425,
    "poll_key": "26-425",
    "date": "2025-10-30",
    "respondents": 500,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 10,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 20,
    "yashar": 4,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 426,
    "poll_key": "26-426",
    "date": "2025-10-30",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 21,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 427,
    "poll_key": "26-427",
    "date": "2025-10-30",
    "respondents": 781,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 12,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 424,
    "poll_key": "26-424",
    "date": "2025-10-29",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 4,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 423,
    "poll_key": "26-423",
    "date": "2025-10-26",
    "respondents": 550,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 21,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 422,
    "poll_key": "26-422",
    "date": "2025-10-24",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 19,
    "yashar": 9,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 418,
    "poll_key": "26-418",
    "date": "2025-10-23",
    "respondents": 601,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 21,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 419,
    "poll_key": "26-419",
    "date": "2025-10-23",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 21,
    "yashar": 7,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 420,
    "poll_key": "26-420",
    "date": "2025-10-23",
    "respondents": 486,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 36,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 11,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 421,
    "poll_key": "26-421",
    "date": "2025-10-23",
    "respondents": 404,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 5,
    "together": 18,
    "yashar": 5,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 417,
    "poll_key": "26-417",
    "date": "2025-10-19",
    "respondents": 519,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 17,
    "yashar": 6,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 416,
    "poll_key": "26-416",
    "date": "2025-10-17",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 20,
    "yashar": 6,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 414,
    "poll_key": "26-414",
    "date": "2025-10-16",
    "respondents": 404,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 7,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 5,
    "together": 20,
    "yashar": 5,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 7,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 415,
    "poll_key": "26-415",
    "date": "2025-10-16",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 22,
    "yashar": 8,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 413,
    "poll_key": "26-413",
    "date": "2025-10-15",
    "respondents": 486,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 35,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 13,
    "yashar": 5,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 412,
    "poll_key": "26-412",
    "date": "2025-10-10",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 19,
    "yashar": 8,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 410,
    "poll_key": "26-410",
    "date": "2025-10-09",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 6,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 4,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 411,
    "poll_key": "26-411",
    "date": "2025-10-09",
    "respondents": 510,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 0,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 16,
    "yashar": 6,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 406,
    "poll_key": "26-406",
    "date": "2025-09-30",
    "respondents": 503,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 7,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 407,
    "poll_key": "26-407",
    "date": "2025-09-30",
    "respondents": 515,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 13,
    "yashar": 10,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 408,
    "poll_key": "26-408",
    "date": "2025-09-30",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 6,
    "hadash_taal": 6,
    "israel_our_home": 7,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 25,
    "yashar": 5,
    "reservists": 0,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 409,
    "poll_key": "26-409",
    "date": "2025-09-30",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": 7,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 405,
    "poll_key": "26-405",
    "date": "2025-09-28",
    "respondents": 493,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": null,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 16,
    "yashar": 6,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 404,
    "poll_key": "26-404",
    "date": "2025-09-26",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 20,
    "yashar": 9,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 403,
    "poll_key": "26-403",
    "date": "2025-09-25",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 5,
    "together": 19,
    "yashar": 8,
    "reservists": 4,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 401,
    "poll_key": "26-401",
    "date": "2025-09-19",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 20,
    "yashar": 9,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 402,
    "poll_key": "26-402",
    "date": "2025-09-19",
    "respondents": 506,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 4,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 20,
    "yashar": 9,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 399,
    "poll_key": "26-399",
    "date": "2025-09-18",
    "respondents": 586,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 4,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 15,
    "yashar": 5,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 400,
    "poll_key": "26-400",
    "date": "2025-09-18",
    "respondents": 505,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 5,
    "together": 21,
    "yashar": 10,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 395,
    "poll_key": "26-395",
    "date": "2025-09-17",
    "respondents": 556,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": null,
    "raam": 5,
    "balad": null,
    "jewish_power": 8,
    "together": 21,
    "yashar": 8,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 396,
    "poll_key": "26-396",
    "date": "2025-09-17",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": null,
    "jewish_power": 9,
    "together": 23,
    "yashar": 5,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 397,
    "poll_key": "26-397",
    "date": "2025-09-17",
    "respondents": 515,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": null,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": null,
    "jewish_power": 6,
    "together": 13,
    "yashar": 10,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 398,
    "poll_key": "26-398",
    "date": "2025-09-17",
    "respondents": 404,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 18,
    "yashar": 12,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 394,
    "poll_key": "26-394",
    "date": "2025-09-12",
    "respondents": 506,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 22,
    "yashar": 9,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 391,
    "poll_key": "26-391",
    "date": "2025-09-11",
    "respondents": 404,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 20,
    "yashar": 7,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 392,
    "poll_key": "26-392",
    "date": "2025-09-11",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 18,
    "yashar": 9,
    "reservists": 6,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 393,
    "poll_key": "26-393",
    "date": "2025-09-11",
    "respondents": 497,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 14,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 390,
    "poll_key": "26-390",
    "date": "2025-09-09",
    "respondents": 504,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 23,
    "yashar": 8,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 389,
    "poll_key": "26-389",
    "date": "2025-09-05",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 24,
    "yashar": 6,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 386,
    "poll_key": "26-386",
    "date": "2025-09-04",
    "respondents": 404,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 7,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 23,
    "yashar": null,
    "reservists": 6,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 387,
    "poll_key": "26-387",
    "date": "2025-09-04",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 19,
    "yashar": 12,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 388,
    "poll_key": "26-388",
    "date": "2025-09-04",
    "respondents": 497,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 4,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 15,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 385,
    "poll_key": "26-385",
    "date": "2025-09-03",
    "respondents": 513,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 20,
    "yashar": null,
    "reservists": 6,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 384,
    "poll_key": "26-384",
    "date": "2025-09-02",
    "respondents": 558,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": 4,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 382,
    "poll_key": "26-382",
    "date": "2025-08-29",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 21,
    "yashar": 7,
    "reservists": 8,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 377,
    "poll_key": "26-377",
    "date": "2025-08-28",
    "respondents": 509,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 20,
    "yashar": 12,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 381,
    "poll_key": "26-381",
    "date": "2025-08-28",
    "respondents": 524,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 5,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 15,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 376,
    "poll_key": "26-376",
    "date": "2025-08-26",
    "respondents": 404,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 4,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 26,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 375,
    "poll_key": "26-375",
    "date": "2025-08-22",
    "respondents": 509,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 21,
    "yashar": 8,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 374,
    "poll_key": "26-374",
    "date": "2025-08-21",
    "respondents": 524,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 16,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 373,
    "poll_key": "26-373",
    "date": "2025-08-20",
    "respondents": 542,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 19,
    "yashar": null,
    "reservists": 5,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 372,
    "poll_key": "26-372",
    "date": "2025-08-17",
    "respondents": 505,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 0,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 20,
    "yashar": 12,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 371,
    "poll_key": "26-371",
    "date": "2025-08-15",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 5,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 21,
    "yashar": 9,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 370,
    "poll_key": "26-370",
    "date": "2025-08-14",
    "respondents": 639,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 17,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 369,
    "poll_key": "26-369",
    "date": "2025-08-10",
    "respondents": 554,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 22,
    "yashar": 7,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 368,
    "poll_key": "26-368",
    "date": "2025-08-08",
    "respondents": 504,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 21,
    "yashar": 11,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 367,
    "poll_key": "26-367",
    "date": "2025-08-07",
    "respondents": 441,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 5,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 14,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 366,
    "poll_key": "26-366",
    "date": "2025-08-03",
    "respondents": 568,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 365,
    "poll_key": "26-365",
    "date": "2025-08-01",
    "respondents": 511,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 4,
    "israel_our_home": 12,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 364,
    "poll_key": "26-364",
    "date": "2025-07-31",
    "respondents": 568,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 4,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 16,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 363,
    "poll_key": "26-363",
    "date": "2025-07-25",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 5,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 361,
    "poll_key": "26-361",
    "date": "2025-07-24",
    "respondents": 568,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 4,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 16,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 362,
    "poll_key": "26-362",
    "date": "2025-07-24",
    "respondents": 633,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 0,
    "there_is_a_future": 5,
    "hadash_taal": 4,
    "israel_our_home": 12,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 26,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 360,
    "poll_key": "26-360",
    "date": "2025-07-23",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 13,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 6,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 358,
    "poll_key": "26-358",
    "date": "2025-07-18",
    "respondents": 506,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 6,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 22,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 357,
    "poll_key": "26-357",
    "date": "2025-07-17",
    "respondents": 483,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 0,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 18,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 359,
    "poll_key": "26-359",
    "date": "2025-07-17",
    "respondents": 404,
    "media_outlet": "זמן ישראל",
    "pollster": "יוסי טאטיקה",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 4,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 5,
    "together": 26,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Times of Israel (Hebrew)",
    "pollster_en": "Yossi Tatika",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 355,
    "poll_key": "26-355",
    "date": "2025-07-16",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 8,
    "blue_and_white": 6,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 23,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 354,
    "poll_key": "26-354",
    "date": "2025-07-14",
    "respondents": 525,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 0,
    "there_is_a_future": 4,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 22,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 353,
    "poll_key": "26-353",
    "date": "2025-07-11",
    "respondents": 511,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 7,
    "there_is_a_future": 7,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 352,
    "poll_key": "26-352",
    "date": "2025-07-04",
    "respondents": 511,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 6,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 351,
    "poll_key": "26-351",
    "date": "2025-07-03",
    "respondents": 658,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 5,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 14,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 349,
    "poll_key": "26-349",
    "date": "2025-07-01",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 6,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 350,
    "poll_key": "26-350",
    "date": "2025-07-01",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 4,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 23,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 346,
    "poll_key": "26-346",
    "date": "2025-06-26",
    "respondents": 458,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 6,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 15,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 347,
    "poll_key": "26-347",
    "date": "2025-06-26",
    "respondents": 513,
    "media_outlet": "i24 news",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 5,
    "there_is_a_future": 4,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 17,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 348,
    "poll_key": "26-348",
    "date": "2025-06-26",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 8,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 344,
    "poll_key": "26-344",
    "date": "2025-06-25",
    "respondents": 583,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 8,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 345,
    "poll_key": "26-345",
    "date": "2025-06-25",
    "respondents": 558,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 7,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 343,
    "poll_key": "26-343",
    "date": "2025-06-24",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 7,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 335,
    "poll_key": "26-335",
    "date": "2025-06-20",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 7,
    "there_is_a_future": 9,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 334,
    "poll_key": "26-334",
    "date": "2025-06-19",
    "respondents": 758,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 6,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 16,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 333,
    "poll_key": "26-333",
    "date": "2025-06-18",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 7,
    "there_is_a_future": 7,
    "hadash_taal": 6,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 6,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 332,
    "poll_key": "26-332",
    "date": "2025-06-14",
    "respondents": 613,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 6,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 16,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 331,
    "poll_key": "26-331",
    "date": "2025-06-13",
    "respondents": 506,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 8,
    "there_is_a_future": 9,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 27,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 330,
    "poll_key": "26-330",
    "date": "2025-06-12",
    "respondents": 603,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 6,
    "there_is_a_future": 5,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": 14,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 329,
    "poll_key": "26-329",
    "date": "2025-06-11",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 7,
    "there_is_a_future": 8,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 27,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 328,
    "poll_key": "26-328",
    "date": "2025-06-09",
    "respondents": 500,
    "media_outlet": "וואלה",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 10,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 26,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Walla",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 327,
    "poll_key": "26-327",
    "date": "2025-06-06",
    "respondents": 506,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 8,
    "there_is_a_future": 9,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": 27,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 326,
    "poll_key": "26-326",
    "date": "2025-06-05",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 6,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 14,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 14,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 324,
    "poll_key": "26-324",
    "date": "2025-06-04",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 7,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 325,
    "poll_key": "26-325",
    "date": "2025-06-04",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 9,
    "there_is_a_future": 8,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 27,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 323,
    "poll_key": "26-323",
    "date": "2025-05-30",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 9,
    "there_is_a_future": 10,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 28,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 322,
    "poll_key": "26-322",
    "date": "2025-05-29",
    "respondents": 672,
    "media_outlet": "ערוץ 14",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 6,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": 13,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 14,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 321,
    "poll_key": "26-321",
    "date": "2025-05-28",
    "respondents": 554,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 8,
    "there_is_a_future": 8,
    "hadash_taal": 6,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 320,
    "poll_key": "26-320",
    "date": "2025-05-25",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 8,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 319,
    "poll_key": "26-319",
    "date": "2025-05-23",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 9,
    "there_is_a_future": 11,
    "hadash_taal": 6,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 28,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 7,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 318,
    "poll_key": "26-318",
    "date": "2025-05-22",
    "respondents": 630,
    "media_outlet": "ערוץ 14",
    "pollster": "צוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 6,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 13,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Tzuriel Sharon",
    "democrats": 14,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 317,
    "poll_key": "26-317",
    "date": "2025-05-20",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 6,
    "there_is_a_future": 7,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 29,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 315,
    "poll_key": "26-315",
    "date": "2025-05-16",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 8,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 27,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 316,
    "poll_key": "26-316",
    "date": "2025-05-16",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 7,
    "there_is_a_future": 8,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 27,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 314,
    "poll_key": "26-314",
    "date": "2025-05-09",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 9,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 312,
    "poll_key": "26-312",
    "date": "2025-05-07",
    "respondents": 500,
    "media_outlet": "מכונת האמת",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 11,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Truth Machine",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 313,
    "poll_key": "26-313",
    "date": "2025-05-07",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 7,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 23,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 14,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 311,
    "poll_key": "26-311",
    "date": "2025-05-05",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 5,
    "there_is_a_future": 7,
    "hadash_taal": 6,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 11,
    "together": 31,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 310,
    "poll_key": "26-310",
    "date": "2025-05-02",
    "respondents": 510,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 8,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 26,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 309,
    "poll_key": "26-309",
    "date": "2025-04-25",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 7,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 26,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 308,
    "poll_key": "26-308",
    "date": "2025-04-21",
    "respondents": 602,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 9,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 307,
    "poll_key": "26-307",
    "date": "2025-04-18",
    "respondents": 508,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 7,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 29,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 306,
    "poll_key": "26-306",
    "date": "2025-04-11",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 8,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 29,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 305,
    "poll_key": "26-305",
    "date": "2025-04-06",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 8,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": 23,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 304,
    "poll_key": "26-304",
    "date": "2025-04-04",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 8,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 29,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 303,
    "poll_key": "26-303",
    "date": "2025-04-02",
    "respondents": 600,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 8,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": 27,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 302,
    "poll_key": "26-302",
    "date": "2025-03-28",
    "respondents": 1004,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 10,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 27,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 301,
    "poll_key": "26-301",
    "date": "2025-03-21",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 9,
    "there_is_a_future": 8,
    "hadash_taal": 6,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 299,
    "poll_key": "26-299",
    "date": "2025-03-17",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 7,
    "there_is_a_future": 11,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": 22,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 300,
    "poll_key": "26-300",
    "date": "2025-03-17",
    "respondents": 504,
    "media_outlet": "i24 news",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 12,
    "there_is_a_future": 7,
    "hadash_taal": 6,
    "israel_our_home": 7,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": 23,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 298,
    "poll_key": "26-298",
    "date": "2025-03-14",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 9,
    "there_is_a_future": 9,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 297,
    "poll_key": "26-297",
    "date": "2025-03-07",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 9,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": 23,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 296,
    "poll_key": "26-296",
    "date": "2025-03-05",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 9,
    "there_is_a_future": 11,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 295,
    "poll_key": "26-295",
    "date": "2025-02-28",
    "respondents": 511,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 9,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 294,
    "poll_key": "26-294",
    "date": "2025-02-23",
    "respondents": 500,
    "media_outlet": "i24 news",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 8,
    "there_is_a_future": 7,
    "hadash_taal": 4,
    "israel_our_home": 7,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": 0,
    "jewish_power": 7,
    "together": 25,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Yitzhak Katz",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 293,
    "poll_key": "26-293",
    "date": "2025-02-21",
    "respondents": 509,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 9,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 292,
    "poll_key": "26-292",
    "date": "2025-02-17",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 8,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": 23,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 291,
    "poll_key": "26-291",
    "date": "2025-02-14",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 10,
    "there_is_a_future": 9,
    "hadash_taal": 6,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 28,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 290,
    "poll_key": "26-290",
    "date": "2025-02-07",
    "respondents": 503,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 11,
    "there_is_a_future": 10,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": 24,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 289,
    "poll_key": "26-289",
    "date": "2025-02-05",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 9,
    "there_is_a_future": 5,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": 29,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 271,
    "poll_key": "26-271",
    "date": "2025-01-31",
    "respondents": 517,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 19,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 270,
    "poll_key": "26-270",
    "date": "2025-01-24",
    "respondents": 517,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 18,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 16,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 267,
    "poll_key": "26-267",
    "date": "2025-01-23",
    "respondents": 505,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 18,
    "there_is_a_future": 14,
    "hadash_taal": 4,
    "israel_our_home": 13,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 268,
    "poll_key": "26-268",
    "date": "2025-01-23",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 18,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Yitzhak Katz",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 269,
    "poll_key": "26-269",
    "date": "2025-01-23",
    "respondents": 521,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 10,
    "there_is_a_future": 6,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": 0,
    "jewish_power": 5,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 17,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 266,
    "poll_key": "26-266",
    "date": "2025-01-22",
    "respondents": 500,
    "media_outlet": "מכונת האמת",
    "pollster": "רפי סמית",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 16,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 16,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Truth Machine",
    "pollster_en": "Rafi Smith",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 265,
    "poll_key": "26-265",
    "date": "2025-01-17",
    "respondents": 509,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 17,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 263,
    "poll_key": "26-263",
    "date": "2025-01-16",
    "respondents": 531,
    "media_outlet": "i24 news",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 18,
    "there_is_a_future": 11,
    "hadash_taal": 6,
    "israel_our_home": 16,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Yitzhak Katz",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 264,
    "poll_key": "26-264",
    "date": "2025-01-16",
    "respondents": 521,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 12,
    "there_is_a_future": 7,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 15,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 262,
    "poll_key": "26-262",
    "date": "2025-01-10",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 261,
    "poll_key": "26-261",
    "date": "2025-01-09",
    "respondents": 498,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 13,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 5,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 260,
    "poll_key": "26-260",
    "date": "2025-01-03",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 18,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 16,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 259,
    "poll_key": "26-259",
    "date": "2025-01-02",
    "respondents": 508,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 15,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 5,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 258,
    "poll_key": "26-258",
    "date": "2024-12-29",
    "respondents": 601,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 18,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 257,
    "poll_key": "26-257",
    "date": "2024-12-27",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 20,
    "there_is_a_future": 16,
    "hadash_taal": 6,
    "israel_our_home": 15,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 256,
    "poll_key": "26-256",
    "date": "2024-12-26",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 13,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 255,
    "poll_key": "26-255",
    "date": "2024-12-25",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 19,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 254,
    "poll_key": "26-254",
    "date": "2024-12-20",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 20,
    "there_is_a_future": 15,
    "hadash_taal": 6,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 253,
    "poll_key": "26-253",
    "date": "2024-12-19",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 13,
    "there_is_a_future": 10,
    "hadash_taal": 4,
    "israel_our_home": 12,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 251,
    "poll_key": "26-251",
    "date": "2024-12-13",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 252,
    "poll_key": "26-252",
    "date": "2024-12-13",
    "respondents": 500,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 249,
    "poll_key": "26-249",
    "date": "2024-12-12",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 19,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 250,
    "poll_key": "26-250",
    "date": "2024-12-12",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 34,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 14,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 248,
    "poll_key": "26-248",
    "date": "2024-12-11",
    "respondents": 676,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 247,
    "poll_key": "26-247",
    "date": "2024-12-09",
    "respondents": 501,
    "media_outlet": "i24 news",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 19,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 246,
    "poll_key": "26-246",
    "date": "2024-12-06",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 19,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 245,
    "poll_key": "26-245",
    "date": "2024-11-29",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 19,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 244,
    "poll_key": "26-244",
    "date": "2024-11-26",
    "respondents": 510,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 18,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 243,
    "poll_key": "26-243",
    "date": "2024-11-22",
    "respondents": 504,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 19,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 242,
    "poll_key": "26-242",
    "date": "2024-11-18",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 19,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 12,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 241,
    "poll_key": "26-241",
    "date": "2024-11-15",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 20,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 240,
    "poll_key": "26-240",
    "date": "2024-11-08",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 13,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 236,
    "poll_key": "26-236",
    "date": "2024-11-06",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 20,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 237,
    "poll_key": "26-237",
    "date": "2024-11-06",
    "respondents": 606,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 21,
    "there_is_a_future": 13,
    "hadash_taal": 6,
    "israel_our_home": 15,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 238,
    "poll_key": "26-238",
    "date": "2024-11-06",
    "respondents": 504,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 16,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 239,
    "poll_key": "26-239",
    "date": "2024-11-06",
    "respondents": 502,
    "media_outlet": "i24 news",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 20,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 16,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 235,
    "poll_key": "26-235",
    "date": "2024-11-01",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 20,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 234,
    "poll_key": "26-234",
    "date": "2024-10-31",
    "respondents": 501,
    "media_outlet": "ישראל היום",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 19,
    "there_is_a_future": 11,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Yitzhak Katz",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 233,
    "poll_key": "26-233",
    "date": "2024-10-28",
    "respondents": 507,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 22,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 232,
    "poll_key": "26-232",
    "date": "2024-10-27",
    "respondents": 523,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 14,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 231,
    "poll_key": "26-231",
    "date": "2024-10-25",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 21,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 230,
    "poll_key": "26-230",
    "date": "2024-10-20",
    "respondents": 676,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 21,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 229,
    "poll_key": "26-229",
    "date": "2024-10-18",
    "respondents": 602,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 20,
    "there_is_a_future": 14,
    "hadash_taal": 6,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 228,
    "poll_key": "26-228",
    "date": "2024-10-15",
    "respondents": 472,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 33,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 15,
    "there_is_a_future": 8,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 227,
    "poll_key": "26-227",
    "date": "2024-10-11",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 20,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 226,
    "poll_key": "26-226",
    "date": "2024-10-02",
    "respondents": 600,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 224,
    "poll_key": "26-224",
    "date": "2024-09-29",
    "respondents": 520,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 15,
    "there_is_a_future": 9,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 225,
    "poll_key": "26-225",
    "date": "2024-09-29",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 21,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 223,
    "poll_key": "26-223",
    "date": "2024-09-27",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 6,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 15,
    "hadash_taal": 6,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 221,
    "poll_key": "26-221",
    "date": "2024-09-26",
    "respondents": 509,
    "media_outlet": "i24 news",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 21,
    "there_is_a_future": 11,
    "hadash_taal": 6,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 222,
    "poll_key": "26-222",
    "date": "2024-09-26",
    "respondents": 583,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 15,
    "there_is_a_future": 9,
    "hadash_taal": 4,
    "israel_our_home": 15,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 220,
    "poll_key": "26-220",
    "date": "2024-09-20",
    "respondents": 606,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 21,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 219,
    "poll_key": "26-219",
    "date": "2024-09-19",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 17,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 218,
    "poll_key": "26-218",
    "date": "2024-09-17",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 22,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 217,
    "poll_key": "26-217",
    "date": "2024-09-13",
    "respondents": 503,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 21,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 216,
    "poll_key": "26-216",
    "date": "2024-09-12",
    "respondents": 536,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 18,
    "there_is_a_future": 10,
    "hadash_taal": 4,
    "israel_our_home": 13,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 215,
    "poll_key": "26-215",
    "date": "2024-09-09",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 21,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 214,
    "poll_key": "26-214",
    "date": "2024-09-06",
    "respondents": 506,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 22,
    "there_is_a_future": 13,
    "hadash_taal": 6,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 213,
    "poll_key": "26-213",
    "date": "2024-09-05",
    "respondents": 536,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 17,
    "there_is_a_future": 11,
    "hadash_taal": 4,
    "israel_our_home": 13,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 212,
    "poll_key": "26-212",
    "date": "2024-09-04",
    "respondents": 600,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 211,
    "poll_key": "26-211",
    "date": "2024-08-30",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 21,
    "there_is_a_future": 14,
    "hadash_taal": 6,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 210,
    "poll_key": "26-210",
    "date": "2024-08-29",
    "respondents": 510,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 17,
    "there_is_a_future": 11,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 209,
    "poll_key": "26-209",
    "date": "2024-08-27",
    "respondents": 608,
    "media_outlet": "i24 news",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 21,
    "there_is_a_future": 11,
    "hadash_taal": 6,
    "israel_our_home": 14,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Yitzhak Katz",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 208,
    "poll_key": "26-208",
    "date": "2024-08-23",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 20,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 206,
    "poll_key": "26-206",
    "date": "2024-08-22",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 22,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 207,
    "poll_key": "26-207",
    "date": "2024-08-22",
    "respondents": 600,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 21,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 205,
    "poll_key": "26-205",
    "date": "2024-08-16",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 21,
    "there_is_a_future": 14,
    "hadash_taal": 6,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 204,
    "poll_key": "26-204",
    "date": "2024-08-15",
    "respondents": 505,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 16,
    "there_is_a_future": 12,
    "hadash_taal": 4,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 203,
    "poll_key": "26-203",
    "date": "2024-08-09",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 20,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 202,
    "poll_key": "26-202",
    "date": "2024-08-08",
    "respondents": 505,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 16,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 14,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 201,
    "poll_key": "26-201",
    "date": "2024-08-02",
    "respondents": 510,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 22,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 15,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 200,
    "poll_key": "26-200",
    "date": "2024-08-01",
    "respondents": 800,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 16,
    "there_is_a_future": 12,
    "hadash_taal": 4,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 6,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 198,
    "poll_key": "26-198",
    "date": "2024-07-26",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 12,
    "hadash_taal": 6,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 199,
    "poll_key": "26-199",
    "date": "2024-07-26",
    "respondents": 1163,
    "media_outlet": "i24 news",
    "pollster": "עדי טימור וריקי הרצברג",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 23,
    "there_is_a_future": 12,
    "hadash_taal": 4,
    "israel_our_home": 12,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Adi Timor and Riki Hertzberg",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 196,
    "poll_key": "26-196",
    "date": "2024-07-25",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 23,
    "there_is_a_future": 13,
    "hadash_taal": 6,
    "israel_our_home": 12,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 11,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 197,
    "poll_key": "26-197",
    "date": "2024-07-25",
    "respondents": 631,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 15,
    "there_is_a_future": 14,
    "hadash_taal": 4,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 195,
    "poll_key": "26-195",
    "date": "2024-07-19",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 23,
    "there_is_a_future": 13,
    "hadash_taal": 6,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 194,
    "poll_key": "26-194",
    "date": "2024-07-18",
    "respondents": 779,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 16,
    "there_is_a_future": 12,
    "hadash_taal": 4,
    "israel_our_home": 13,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 11,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 193,
    "poll_key": "26-193",
    "date": "2024-07-12",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 24,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 192,
    "poll_key": "26-192",
    "date": "2024-07-11",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 16,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 14,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 191,
    "poll_key": "26-191",
    "date": "2024-07-09",
    "respondents": 500,
    "media_outlet": "i24 news",
    "pollster": "עדי טימור וריקי הרצברג",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 22,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 6,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "i24 news",
    "pollster_en": "Adi Timor and Riki Hertzberg",
    "democrats": 8,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 190,
    "poll_key": "26-190",
    "date": "2024-07-07",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 25,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 12,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "democrats": 9,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 189,
    "poll_key": "26-189",
    "date": "2024-07-05",
    "respondents": 600,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 23,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 188,
    "poll_key": "26-188",
    "date": "2024-07-04",
    "respondents": 858,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 17,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 13,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "democrats": 10,
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 187,
    "poll_key": "26-187",
    "date": "2024-06-28",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 24,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 186,
    "poll_key": "26-186",
    "date": "2024-06-25",
    "respondents": 843,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 17,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 14,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 185,
    "poll_key": "26-185",
    "date": "2024-06-24",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 184,
    "poll_key": "26-184",
    "date": "2024-06-23",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 25,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Yitzhak Katz",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 183,
    "poll_key": "26-183",
    "date": "2024-06-21",
    "respondents": 510,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 182,
    "poll_key": "26-182",
    "date": "2024-06-20",
    "respondents": 514,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 18,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 14,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 180,
    "poll_key": "26-180",
    "date": "2024-06-14",
    "respondents": 544,
    "media_outlet": "ישראל היום",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 24,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Yitzhak Katz",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 181,
    "poll_key": "26-181",
    "date": "2024-06-14",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 24,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 14,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 176,
    "poll_key": "26-176",
    "date": "2024-06-10",
    "respondents": 507,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 22,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 13,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 177,
    "poll_key": "26-177",
    "date": "2024-06-10",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "אריאל איילון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 25,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Ariel Ayalon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 178,
    "poll_key": "26-178",
    "date": "2024-06-10",
    "respondents": 605,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 179,
    "poll_key": "26-179",
    "date": "2024-06-10",
    "respondents": 512,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 17,
    "there_is_a_future": 12,
    "hadash_taal": 4,
    "israel_our_home": 13,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 175,
    "poll_key": "26-175",
    "date": "2024-06-07",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 174,
    "poll_key": "26-174",
    "date": "2024-06-06",
    "respondents": 778,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 17,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 14,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 173,
    "poll_key": "26-173",
    "date": "2024-06-02",
    "respondents": 605,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 172,
    "poll_key": "26-172",
    "date": "2024-05-31",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 25,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 171,
    "poll_key": "26-171",
    "date": "2024-05-30",
    "respondents": 925,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 12,
    "hadash_taal": 4,
    "israel_our_home": 13,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 170,
    "poll_key": "26-170",
    "date": "2024-05-29",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 25,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 169,
    "poll_key": "26-169",
    "date": "2024-05-24",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 29,
    "there_is_a_future": 14,
    "hadash_taal": 6,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 168,
    "poll_key": "26-168",
    "date": "2024-05-23",
    "respondents": 600,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 167,
    "poll_key": "26-167",
    "date": "2024-05-17",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 30,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 165,
    "poll_key": "26-165",
    "date": "2024-05-16",
    "respondents": 925,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 20,
    "there_is_a_future": 14,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 166,
    "poll_key": "26-166",
    "date": "2024-05-16",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 164,
    "poll_key": "26-164",
    "date": "2024-05-10",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 32,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 163,
    "poll_key": "26-163",
    "date": "2024-05-09",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 162,
    "poll_key": "26-162",
    "date": "2024-05-08",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "אריאל איילון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 30,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": 0,
    "jewish_power": 12,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Ariel Ayalon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 161,
    "poll_key": "26-161",
    "date": "2024-05-03",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 31,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 159,
    "poll_key": "26-159",
    "date": "2024-04-30",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 31,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 160,
    "poll_key": "26-160",
    "date": "2024-04-30",
    "respondents": 601,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 158,
    "poll_key": "26-158",
    "date": "2024-04-26",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 29,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 157,
    "poll_key": "26-157",
    "date": "2024-04-21",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "אריאל איילון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 30,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 7,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Ariel Ayalon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 156,
    "poll_key": "26-156",
    "date": "2024-04-19",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 31,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 155,
    "poll_key": "26-155",
    "date": "2024-04-15",
    "respondents": 816,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 22,
    "there_is_a_future": 11,
    "hadash_taal": 4,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 154,
    "poll_key": "26-154",
    "date": "2024-04-12",
    "respondents": 508,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 30,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 12,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 150,
    "poll_key": "26-150",
    "date": "2024-04-07",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 32,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 151,
    "poll_key": "26-151",
    "date": "2024-04-07",
    "respondents": 601,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 30,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 152,
    "poll_key": "26-152",
    "date": "2024-04-07",
    "respondents": 587,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 11,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": [
      "exact_payload_duplicate_group_2"
    ]
  },
  {
    "election": 26,
    "poll_id": 153,
    "poll_key": "26-153",
    "date": "2024-04-07",
    "respondents": 587,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 11,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": [
      "exact_payload_duplicate_group_2"
    ]
  },
  {
    "election": 26,
    "poll_id": 149,
    "poll_key": "26-149",
    "date": "2024-04-05",
    "respondents": 528,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 6,
    "shas": 9,
    "blue_and_white": 32,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 148,
    "poll_key": "26-148",
    "date": "2024-03-31",
    "respondents": 589,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 22,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 6,
    "raam": 6,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 147,
    "poll_key": "26-147",
    "date": "2024-03-29",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 33,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 146,
    "poll_key": "26-146",
    "date": "2024-03-22",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 6,
    "shas": 10,
    "blue_and_white": 35,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 145,
    "poll_key": "26-145",
    "date": "2024-03-15",
    "respondents": 601,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 6,
    "shas": 10,
    "blue_and_white": 36,
    "there_is_a_future": 11,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 141,
    "poll_key": "26-141",
    "date": "2024-03-13",
    "respondents": 553,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 21,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 30,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 142,
    "poll_key": "26-142",
    "date": "2024-03-13",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 33,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 143,
    "poll_key": "26-143",
    "date": "2024-03-13",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 34,
    "there_is_a_future": 14,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 144,
    "poll_key": "26-144",
    "date": "2024-03-13",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 22,
    "there_is_a_future": 12,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 140,
    "poll_key": "26-140",
    "date": "2024-03-12",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 35,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 139,
    "poll_key": "26-139",
    "date": "2024-03-08",
    "respondents": 510,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 6,
    "shas": 10,
    "blue_and_white": 40,
    "there_is_a_future": 10,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 138,
    "poll_key": "26-138",
    "date": "2024-03-03",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 39,
    "there_is_a_future": 12,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 137,
    "poll_key": "26-137",
    "date": "2024-03-02",
    "respondents": 20839,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 10,
    "hadash_taal": 0,
    "israel_our_home": 11,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 4,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": [
      "respondents_outlier"
    ]
  },
  {
    "election": 26,
    "poll_id": 136,
    "poll_key": "26-136",
    "date": "2024-03-01",
    "respondents": 511,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 6,
    "shas": 10,
    "blue_and_white": 41,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 135,
    "poll_key": "26-135",
    "date": "2024-02-23",
    "respondents": 508,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 6,
    "shas": 10,
    "blue_and_white": 39,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 4,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 134,
    "poll_key": "26-134",
    "date": "2024-02-16",
    "respondents": 515,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 40,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 133,
    "poll_key": "26-133",
    "date": "2024-02-13",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 26,
    "there_is_a_future": 12,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 131,
    "poll_key": "26-131",
    "date": "2024-02-11",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 37,
    "there_is_a_future": 13,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 6,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 132,
    "poll_key": "26-132",
    "date": "2024-02-11",
    "respondents": 510,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 37,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 130,
    "poll_key": "26-130",
    "date": "2024-02-09",
    "respondents": 514,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 36,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 10,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 128,
    "poll_key": "26-128",
    "date": "2024-02-02",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 34,
    "there_is_a_future": 15,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Yitzhak Katz",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 129,
    "poll_key": "26-129",
    "date": "2024-02-02",
    "respondents": 511,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 6,
    "shas": 9,
    "blue_and_white": 38,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 127,
    "poll_key": "26-127",
    "date": "2024-01-30",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 37,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 126,
    "poll_key": "26-126",
    "date": "2024-01-26",
    "respondents": 513,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 16,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 40,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 125,
    "poll_key": "26-125",
    "date": "2024-01-25",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 26,
    "there_is_a_future": 12,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 124,
    "poll_key": "26-124",
    "date": "2024-01-21",
    "respondents": 602,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 16,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 37,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 6,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 123,
    "poll_key": "26-123",
    "date": "2024-01-19",
    "respondents": 512,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 16,
    "united_torah_judaism": 6,
    "shas": 9,
    "blue_and_white": 39,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 122,
    "poll_key": "26-122",
    "date": "2024-01-14",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 14,
    "hadash_taal": 4,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 4,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 121,
    "poll_key": "26-121",
    "date": "2024-01-12",
    "respondents": 515,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 16,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 39,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 120,
    "poll_key": "26-120",
    "date": "2024-01-11",
    "respondents": 511,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 35,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 119,
    "poll_key": "26-119",
    "date": "2024-01-07",
    "respondents": 600,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 33,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 118,
    "poll_key": "26-118",
    "date": "2024-01-06",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 27,
    "there_is_a_future": 14,
    "hadash_taal": 4,
    "israel_our_home": 10,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 9,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 117,
    "poll_key": "26-117",
    "date": "2024-01-05",
    "respondents": 519,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 6,
    "shas": 9,
    "blue_and_white": 36,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 116,
    "poll_key": "26-116",
    "date": "2023-12-29",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 38,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 115,
    "poll_key": "26-115",
    "date": "2023-12-28",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 16,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 38,
    "there_is_a_future": 15,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 114,
    "poll_key": "26-114",
    "date": "2023-12-22",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 38,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 113,
    "poll_key": "26-113",
    "date": "2023-12-21",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 11,
    "religious_zionism_identity": 4,
    "raam": 6,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 112,
    "poll_key": "26-112",
    "date": "2023-12-18",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 37,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 0,
    "raam": 5,
    "balad": 0,
    "jewish_power": 8,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 111,
    "poll_key": "26-111",
    "date": "2023-12-15",
    "respondents": 510,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 39,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 4,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 110,
    "poll_key": "26-110",
    "date": "2023-12-11",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 37,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 5,
    "raam": 5,
    "balad": 0,
    "jewish_power": 7,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 105,
    "poll_key": "26-105",
    "date": "2023-12-08",
    "respondents": 505,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 38,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 10,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 104,
    "poll_key": "26-104",
    "date": "2023-12-01",
    "respondents": 603,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 40,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 10,
    "religious_zionism_identity": 7,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 103,
    "poll_key": "26-103",
    "date": "2023-11-24",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 43,
    "there_is_a_future": 13,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 7,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 102,
    "poll_key": "26-102",
    "date": "2023-11-17",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 42,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 101,
    "poll_key": "26-101",
    "date": "2023-11-16",
    "respondents": 502,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 17,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 36,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 100,
    "poll_key": "26-100",
    "date": "2023-11-10",
    "respondents": 515,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 40,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 9,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 99,
    "poll_key": "26-99",
    "date": "2023-11-03",
    "respondents": 515,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 39,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 98,
    "poll_key": "26-98",
    "date": "2023-10-27",
    "respondents": 522,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 36,
    "there_is_a_future": 17,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 97,
    "poll_key": "26-97",
    "date": "2023-10-20",
    "respondents": 510,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 18,
    "united_torah_judaism": 7,
    "shas": 8,
    "blue_and_white": 40,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 10,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 96,
    "poll_key": "26-96",
    "date": "2023-10-13",
    "respondents": 600,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 19,
    "united_torah_judaism": 7,
    "shas": 7,
    "blue_and_white": 41,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 95,
    "poll_key": "26-95",
    "date": "2023-10-06",
    "respondents": 501,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 94,
    "poll_key": "26-94",
    "date": "2023-09-29",
    "respondents": 505,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 17,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 91,
    "poll_key": "26-91",
    "date": "2023-09-26",
    "respondents": 601,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 30,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 92,
    "poll_key": "26-92",
    "date": "2023-09-26",
    "respondents": 702,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 4,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 93,
    "poll_key": "26-93",
    "date": "2023-09-26",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 89,
    "poll_key": "26-89",
    "date": "2023-09-22",
    "respondents": 809,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 16,
    "hadash_taal": 4,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 90,
    "poll_key": "26-90",
    "date": "2023-09-22",
    "respondents": 507,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 31,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 87,
    "poll_key": "26-87",
    "date": "2023-09-15",
    "respondents": 525,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 31,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 88,
    "poll_key": "26-88",
    "date": "2023-09-14",
    "respondents": 683,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 16,
    "hadash_taal": 4,
    "israel_our_home": 7,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 86,
    "poll_key": "26-86",
    "date": "2023-09-13",
    "respondents": 697,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 85,
    "poll_key": "26-85",
    "date": "2023-09-10",
    "respondents": 505,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 84,
    "poll_key": "26-84",
    "date": "2023-09-08",
    "respondents": 517,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 30,
    "there_is_a_future": 17,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 83,
    "poll_key": "26-83",
    "date": "2023-09-06",
    "respondents": 927,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 15,
    "hadash_taal": 4,
    "israel_our_home": 7,
    "religious_zionism_identity": 11,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 82,
    "poll_key": "26-82",
    "date": "2023-09-04",
    "respondents": 702,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 26,
    "there_is_a_future": 20,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 80,
    "poll_key": "26-80",
    "date": "2023-09-01",
    "respondents": 512,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 31,
    "there_is_a_future": 17,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 81,
    "poll_key": "26-81",
    "date": "2023-08-31",
    "respondents": 523,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 6,
    "shas": 10,
    "blue_and_white": 26,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 8,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 79,
    "poll_key": "26-79",
    "date": "2023-08-25",
    "respondents": 608,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 30,
    "there_is_a_future": 16,
    "hadash_taal": 6,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 78,
    "poll_key": "26-78",
    "date": "2023-08-18",
    "respondents": 511,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 31,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 77,
    "poll_key": "26-77",
    "date": "2023-08-11",
    "respondents": 511,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 29,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 75,
    "poll_key": "26-75",
    "date": "2023-08-04",
    "respondents": 507,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 30,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 76,
    "poll_key": "26-76",
    "date": "2023-08-04",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 20,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 74,
    "poll_key": "26-74",
    "date": "2023-08-03",
    "respondents": 720,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 25,
    "there_is_a_future": 16,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 72,
    "poll_key": "26-72",
    "date": "2023-07-28",
    "respondents": 500,
    "media_outlet": "ישראל היום",
    "pollster": "יצחק כ״ץ",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 21,
    "hadash_taal": 4,
    "israel_our_home": 4,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Israel Hayom",
    "pollster_en": "Yitzhak Katz",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 73,
    "poll_key": "26-73",
    "date": "2023-07-28",
    "respondents": 504,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 30,
    "there_is_a_future": 16,
    "hadash_taal": 4,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 70,
    "poll_key": "26-70",
    "date": "2023-07-25",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 19,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 8,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 71,
    "poll_key": "26-71",
    "date": "2023-07-25",
    "respondents": 711,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 30,
    "there_is_a_future": 17,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 69,
    "poll_key": "26-69",
    "date": "2023-07-24",
    "respondents": 1143,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 28,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 68,
    "poll_key": "26-68",
    "date": "2023-07-23",
    "respondents": 602,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 30,
    "there_is_a_future": 17,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 67,
    "poll_key": "26-67",
    "date": "2023-07-21",
    "respondents": 525,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 29,
    "there_is_a_future": 17,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 66,
    "poll_key": "26-66",
    "date": "2023-07-20",
    "respondents": 500,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 29,
    "there_is_a_future": 21,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 65,
    "poll_key": "26-65",
    "date": "2023-07-14",
    "respondents": 516,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 26,
    "there_is_a_future": 18,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 63,
    "poll_key": "26-63",
    "date": "2023-07-13",
    "respondents": 697,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 27,
    "there_is_a_future": 21,
    "hadash_taal": 4,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 7,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 64,
    "poll_key": "26-64",
    "date": "2023-07-13",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 28,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 61,
    "poll_key": "26-61",
    "date": "2023-07-09",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 26,
    "there_is_a_future": 20,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 62,
    "poll_key": "26-62",
    "date": "2023-07-09",
    "respondents": 606,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 17,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 60,
    "poll_key": "26-60",
    "date": "2023-07-07",
    "respondents": 517,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 26,
    "there_is_a_future": 20,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 59,
    "poll_key": "26-59",
    "date": "2023-07-06",
    "respondents": 472,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 11,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 58,
    "poll_key": "26-58",
    "date": "2023-07-05",
    "respondents": 701,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 26,
    "there_is_a_future": 18,
    "hadash_taal": 4,
    "israel_our_home": 6,
    "religious_zionism_identity": 13,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 57,
    "poll_key": "26-57",
    "date": "2023-06-30",
    "respondents": 513,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 28,
    "there_is_a_future": 19,
    "hadash_taal": 6,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 56,
    "poll_key": "26-56",
    "date": "2023-06-29",
    "respondents": 779,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 14,
    "hadash_taal": 4,
    "israel_our_home": 8,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 54,
    "poll_key": "26-54",
    "date": "2023-06-26",
    "respondents": 516,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 18,
    "hadash_taal": 4,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 55,
    "poll_key": "26-55",
    "date": "2023-06-26",
    "respondents": 702,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 20,
    "hadash_taal": 4,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 53,
    "poll_key": "26-53",
    "date": "2023-06-23",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 30,
    "there_is_a_future": 17,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 52,
    "poll_key": "26-52",
    "date": "2023-06-16",
    "respondents": 512,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 32,
    "there_is_a_future": 17,
    "hadash_taal": 6,
    "israel_our_home": 5,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 50,
    "poll_key": "26-50",
    "date": "2023-06-15",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 28,
    "there_is_a_future": 17,
    "hadash_taal": 6,
    "israel_our_home": 5,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 4,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 51,
    "poll_key": "26-51",
    "date": "2023-06-15",
    "respondents": 516,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 49,
    "poll_key": "26-49",
    "date": "2023-06-11",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 19,
    "hadash_taal": 6,
    "israel_our_home": 5,
    "religious_zionism_identity": 11,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 48,
    "poll_key": "26-48",
    "date": "2023-06-09",
    "respondents": 502,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 31,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 47,
    "poll_key": "26-47",
    "date": "2023-06-08",
    "respondents": 592,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 26,
    "there_is_a_future": 15,
    "hadash_taal": 5,
    "israel_our_home": 7,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 46,
    "poll_key": "26-46",
    "date": "2023-06-02",
    "respondents": 506,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 29,
    "there_is_a_future": 18,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 45,
    "poll_key": "26-45",
    "date": "2023-05-30",
    "respondents": 510,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 18,
    "hadash_taal": 4,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 44,
    "poll_key": "26-44",
    "date": "2023-05-25",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 27,
    "there_is_a_future": 18,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 43,
    "poll_key": "26-43",
    "date": "2023-05-24",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 29,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 4,
    "religious_zionism_identity": 9,
    "raam": 6,
    "balad": 4,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 42,
    "poll_key": "26-42",
    "date": "2023-05-19",
    "respondents": 513,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 28,
    "there_is_a_future": 16,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 12,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 38,
    "poll_key": "26-38",
    "date": "2023-05-14",
    "respondents": 622,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 16,
    "hadash_taal": 4,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 39,
    "poll_key": "26-39",
    "date": "2023-05-14",
    "respondents": 501,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 40,
    "poll_key": "26-40",
    "date": "2023-05-14",
    "respondents": 605,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 26,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 41,
    "poll_key": "26-41",
    "date": "2023-05-14",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 30,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 13,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 37,
    "poll_key": "26-37",
    "date": "2023-05-12",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 27,
    "there_is_a_future": 17,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 35,
    "poll_key": "26-35",
    "date": "2023-05-07",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 36,
    "poll_key": "26-36",
    "date": "2023-05-07",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 19,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 34,
    "poll_key": "26-34",
    "date": "2023-05-05",
    "respondents": 517,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 31,
    "there_is_a_future": 17,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 32,
    "poll_key": "26-32",
    "date": "2023-04-30",
    "respondents": 500,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 28,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 33,
    "poll_key": "26-33",
    "date": "2023-04-30",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 22,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 28,
    "there_is_a_future": 18,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 4,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 31,
    "poll_key": "26-31",
    "date": "2023-04-29",
    "respondents": 600,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 30,
    "there_is_a_future": 18,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 30,
    "poll_key": "26-30",
    "date": "2023-04-28",
    "respondents": 525,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 23,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 17,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 29,
    "poll_key": "26-29",
    "date": "2023-04-21",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 27,
    "there_is_a_future": 19,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 10,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 27,
    "poll_key": "26-27",
    "date": "2023-04-16",
    "respondents": 504,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 24,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 28,
    "there_is_a_future": 20,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 28,
    "poll_key": "26-28",
    "date": "2023-04-16",
    "respondents": 1115,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 10,
    "blue_and_white": 29,
    "there_is_a_future": 14,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 26,
    "poll_key": "26-26",
    "date": "2023-04-14",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 26,
    "there_is_a_future": 19,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 9,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 25,
    "poll_key": "26-25",
    "date": "2023-04-09",
    "respondents": 699,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 20,
    "united_torah_judaism": 6,
    "shas": 9,
    "blue_and_white": 29,
    "there_is_a_future": 21,
    "hadash_taal": 6,
    "israel_our_home": 5,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 4,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 24,
    "poll_key": "26-24",
    "date": "2023-04-07",
    "respondents": 522,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 25,
    "there_is_a_future": 20,
    "hadash_taal": 6,
    "israel_our_home": 6,
    "religious_zionism_identity": 12,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 23,
    "poll_key": "26-23",
    "date": "2023-03-28",
    "respondents": 700,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 19,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 21,
    "poll_key": "26-21",
    "date": "2023-03-27",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 23,
    "there_is_a_future": 22,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 12,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 22,
    "poll_key": "26-22",
    "date": "2023-03-27",
    "respondents": 600,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 25,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 21,
    "there_is_a_future": 22,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 20,
    "poll_key": "26-20",
    "date": "2023-03-26",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 18,
    "there_is_a_future": 24,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 11,
    "raam": 5,
    "balad": 4,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 19,
    "poll_key": "26-19",
    "date": "2023-03-24",
    "respondents": 713,
    "media_outlet": "ג׳רוזלם פוסט",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 26,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 11,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "The Jerusalem Post",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 17,
    "poll_key": "26-17",
    "date": "2023-03-17",
    "respondents": 508,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 8,
    "shas": 9,
    "blue_and_white": 16,
    "there_is_a_future": 24,
    "hadash_taal": 4,
    "israel_our_home": 6,
    "religious_zionism_identity": 11,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 18,
    "poll_key": "26-18",
    "date": "2023-03-17",
    "respondents": 503,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 17,
    "there_is_a_future": 23,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 12,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 14,
    "poll_key": "26-14",
    "date": "2023-03-16",
    "respondents": 600,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 17,
    "there_is_a_future": 24,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 12,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 15,
    "poll_key": "26-15",
    "date": "2023-03-16",
    "respondents": 993,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 32,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 15,
    "there_is_a_future": 23,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 12,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 16,
    "poll_key": "26-16",
    "date": "2023-03-16",
    "respondents": 700,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 13,
    "there_is_a_future": 27,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 13,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 13,
    "poll_key": "26-13",
    "date": "2023-03-10",
    "respondents": 507,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 16,
    "there_is_a_future": 25,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 12,
    "raam": 4,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 11,
    "poll_key": "26-11",
    "date": "2023-03-05",
    "respondents": 512,
    "media_outlet": "ערוץ 14",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 12,
    "blue_and_white": 12,
    "there_is_a_future": 24,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 14,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 12,
    "poll_key": "26-12",
    "date": "2023-03-05",
    "respondents": 701,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 28,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 14,
    "there_is_a_future": 27,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 12,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 10,
    "poll_key": "26-10",
    "date": "2023-02-28",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 14,
    "there_is_a_future": 26,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 12,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 9,
    "poll_key": "26-9",
    "date": "2023-02-27",
    "respondents": 1001,
    "media_outlet": "כאן חדשות",
    "pollster": "דודי חסיד",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 29,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 15,
    "there_is_a_future": 26,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 13,
    "raam": 6,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Kan News",
    "pollster_en": "Dudi Hasid",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 7,
    "poll_key": "26-7",
    "date": "2023-02-24",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 26,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 19,
    "there_is_a_future": 27,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 12,
    "raam": 0,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 8,
    "poll_key": "26-8",
    "date": "2023-02-24",
    "respondents": 806,
    "media_outlet": "ערוץ 7",
    "pollster": "דירקט פולס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 8,
    "shas": 11,
    "blue_and_white": 13,
    "there_is_a_future": 23,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 14,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 7",
    "pollster_en": "Direct Polls",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 6,
    "poll_key": "26-6",
    "date": "2023-02-20",
    "respondents": 902,
    "media_outlet": "חדשות 13",
    "pollster": "קמיל פוקס",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 27,
    "united_torah_judaism": 7,
    "shas": 10,
    "blue_and_white": 14,
    "there_is_a_future": 26,
    "hadash_taal": 5,
    "israel_our_home": 5,
    "religious_zionism_identity": 12,
    "raam": 6,
    "balad": 4,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 13 News",
    "pollster_en": "Camil Fuchs",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 4,
    "poll_key": "26-4",
    "date": "2023-02-03",
    "respondents": 500,
    "media_outlet": "חדשות 12",
    "pollster": "מנו גבע",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 7,
    "shas": 11,
    "blue_and_white": 14,
    "there_is_a_future": 24,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 14,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 12 News",
    "pollster_en": "Mano Geva",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 5,
    "poll_key": "26-5",
    "date": "2023-02-03",
    "respondents": 512,
    "media_outlet": "ערוץ 14",
    "pollster": "שלמה פילבר וצוריאל שרון",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 30,
    "united_torah_judaism": 8,
    "shas": 12,
    "blue_and_white": 12,
    "there_is_a_future": 24,
    "hadash_taal": 5,
    "israel_our_home": 6,
    "religious_zionism_identity": 14,
    "raam": 5,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Channel 14",
    "pollster_en": "Shlomo Filber and Tzuriel Sharon",
    "audit_flags": []
  },
  {
    "election": 26,
    "poll_id": 3,
    "poll_key": "26-3",
    "date": "2023-01-27",
    "respondents": 500,
    "media_outlet": "מעריב",
    "pollster": "מנחם לזר",
    "source_url": "https://themadad.com/allpolls/",
    "likud": 31,
    "united_torah_judaism": 7,
    "shas": 9,
    "blue_and_white": 15,
    "there_is_a_future": 27,
    "hadash_taal": 4,
    "israel_our_home": 5,
    "religious_zionism_identity": 13,
    "raam": 0,
    "balad": 0,
    "jewish_power": null,
    "together": null,
    "yashar": null,
    "reservists": null,
    "joint_list": null,
    "erdan_edelstein_party": null,
    "people_of_israel": null,
    "media_outlet_en": "Maariv",
    "pollster_en": "Menachem Lazar",
    "audit_flags": []
  }
]
